/**
 * Publisher class used to publish state change events.
 */
export default class PubSub {
    _callbackList: {};

    constructor() {
        /** @type {object} list of subscribed publish callbacks */
        this._callbackList = {};
    }

    /**
     * Publishes to subscriber callbacks that are subscribed
     * to the changing state name (property)
     *
     * @param {String} stateName - target state name to publish update on
     * @param {any} nextValue - Next/Future state value/object
     */
    publish(stateName: string, nextValue: any): void {
        const listKeys = Object.keys(this._callbackList);

        for (let i = 0; i < listKeys.length; i++) {
            const item = this._callbackList[listKeys[i]];

            if (stateName === item.stateName) {
                item.callback(nextValue);
            }
        }
    }

    /**
     * Subscribe to given state name, will call callback function
     * on state changes.
     *
     * @param {function} callback - Function to callback when item
     * 							    with stateName changes
     * @param {String} stateName - state name to subscribe to
     *                             (can be an object path ex: item.name)
     * @returns {Integer} - id of the subscription, to be used for unsubscribe
     */
    subscribe(callback: Function, stateName: string): number {
        if (typeof callback !== "function") {
            throw new Error("callback should be a function");
        }

        if (typeof stateName !== "string") {
            throw new Error("stateName should be a string");
        }

        // Get a random subscriptionId
        const subscriptionId = Math.round(
            Math.random() * Number.MAX_SAFE_INTEGER
        );

        if (!this._callbackList[subscriptionId]) {
            this._callbackList[subscriptionId] = { callback, stateName };
            return subscriptionId;
        }

        // id exists get another.
        return (this.subscribe(callback, stateName));
    }

    /**
     * Unsubscribe from state change callbacks.
     * @param {Integer} subscriptionId - id to unsubscribe from
     * (from subscribe)
     * @returns {Boolean} - true if found and unsubscribed
     */
    unsubscribe(subscriptionId: number): boolean {
        if (this._callbackList[subscriptionId]) {
            delete this._callbackList[subscriptionId];
            return true;
        }
        return false;
    }
}
